// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'setimmediate';
import 'pixi.js';
import 'pixi-spine';
import _ from 'lodash';
import 'reflect-metadata';
import BootstrapVue from 'bootstrap-vue';
import '@/assets/style/_bootstrap.scss';
import VModal from 'tombola-vue-js-modal';
import '@/assets/style/_theme.scss';
import '@/assets/style/_vuebar.scss';
import '@/assets/style/_profile.scss';
import '@/assets/style/_sweetalert-custom.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'font-awesome/css/font-awesome.css';
import '@/helper/string-extensions';
import Vue from 'vue';
import Vuex from 'vuex';
import VueResize from 'vue-resize';
import 'vue-resize/dist/vue-resize.css';
import App from '@/components/app/app.vue';
import Configuration from '@/plugins/configuration';
import Localisation from '@/plugins/localisation';
import TombolaModalManager from '@/plugins/modal-manager';
import router from '@/app-modules/router';
import TombolaLocalStorage from '@/plugins/store';
import VeeValidate from 'vee-validate';
import IoC from '@/plugins/ioc';
import EventBus from '@/plugins/event-bus';
import ErrorService from '@/app-modules/error';
import sharedComponents from '@/components/shared-components';
import '@/app-modules/utils/axios-interceptors';

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VModal);
const config = ({ fieldsBagName: 'veeFields' }) as never;
Vue.use(VeeValidate, config);
Vue.use(VueResize);

Localisation.init('en');
Configuration.init('en');
TombolaLocalStorage.init();
IoC.init();
ErrorService.init();
EventBus.init();
TombolaModalManager.init();

Vue.config.productionTip = false;

for (const sharedComponentName in sharedComponents) {
  if (sharedComponents.hasOwnProperty(sharedComponentName)) {
    const sharedComponentType = sharedComponents[sharedComponentName];
    const sharedComponentId = _.kebabCase(sharedComponentName);
    Vue.component(sharedComponentId, sharedComponentType);
  }
}

new Vue({
  el: '#app',
  router,
  components: { App },
  render: (h) => h(App)
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main.ts